/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Partial_Italics_LabelInputs */



/**
* | output |
* | --- |
* | "Partial Italics" |
*
* @param {Style_Guide_Manager_Partial_Italics_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_partial_italics_label = /** @type {((inputs?: Style_Guide_Manager_Partial_Italics_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Partial_Italics_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Italique partiel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilweise Kursivschrift")
	if (locale === "it") return /** @type {LocalizedString} */ ("Corsivo parziale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Частичный курсив")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cursiva parcial")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分斜体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("部分イタリック体")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आंशिक इटैलिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Itálico parcial")
	return /** @type {LocalizedString} */ ("Partial Italics")
});